import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class ToastrAlertService {

  constructor(private toast: ToastrService, private router: Router) {
    toast.toastrConfig.preventDuplicates = true;
  }

  infoToastr(message: string, title: string = '') {
    this.toast.info(message, title);
  }

  successToastr(message: string, title: string = '') {
    this.toast.success(message, title);

  }

  errorToastr(message: string, title: string = '') {
    
      //Log current route (page)
      const url = this.router.url;

      // Capture stack trace
      const stack = new Error().stack;
      const timestamp = new Date().toISOString();

      // You can pretty print or send to a logger
      // eslint-disable-next-line no-console
      console.groupCollapsed(`errorToastr called | route: ${url} | title: ${title}`);
      console.log('message:', message);
      console.log('stack:', stack);
      console.groupEnd();


// const log = [
//     `=== errorToastr called @ ${timestamp} ===`,
//     `Route: ${url}`,
//     `Title: ${title}`,
//     `Message: ${message}`,
//     `Stack:`,
//     stack,
//     `\n`
//   ].join('\n');

  // Save as a file (Notepad can open .txt)
 // this.downloadTextFile(`error-log-${Date.now()}.txt`, log);

    this.toast.error(message, title);
    

  }
  warningToastr(message: string, title: string = '') {
    this.toast.warning(message, title);
  }

  
// private downloadTextFile(filename: string, content: string) {
//   const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
//   const url = URL.createObjectURL(blob);
//   const a = document.createElement('a');
//   a.href = url;
//   a.download = filename;
//   document.body.appendChild(a);
//   a.click();
//   document.body.removeChild(a);
//   URL.revokeObjectURL(url);
// }

}